import React, { useEffect, useState } from 'react';
import { Camera, ChevronRight } from 'lucide-react';
import api from '../lib/api';
import Lookbook from '../components/Lookbook';
import { resolveImageUrl } from '../lib/images';

const LookbookPage = () => {
  const [lookbooks, setLookbooks] = useState([]);
  const [active, setActive] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get('/lookbooks');
        if (!cancelled && res.data?.success) setLookbooks(res.data.data || []);
      } catch {/* swallow */}
      finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="min-h-[80vh] bg-neutral-100 p-6 md:p-12">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <Camera size={32} />
          <h1 className="text-5xl md:text-7xl font-black tracking-tighter">LOOKBOOK</h1>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array(3).fill(0).map((_, i) => (
              <div key={i} className="bg-white border-4 border-black h-80 animate-pulse" />
            ))}
          </div>
        ) : lookbooks.length === 0 ? (
          <div className="bg-yellow-300 border-4 border-black p-16 text-center shadow-[16px_16px_0px_black]">
            <h2 className="text-4xl md:text-6xl font-black mb-4">SHOOT IN PROGRESS</h2>
            <p className="font-mono">First lookbook drops soon. Stay tuned.</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {lookbooks.map((lb) => {
              const cover = lb.coverImage?.url || lb.spreads?.[0]?.images?.[0]?.url;
              return (
                <button
                  key={lb._id}
                  onClick={() => setActive(lb)}
                  className="group text-left bg-white border-4 border-black overflow-hidden shadow-[8px_8px_0px_black] hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-all"
                >
                  {cover ? (
                    <img src={resolveImageUrl(cover)} alt={lb.title} className="w-full aspect-[4/5] object-cover" />
                  ) : (
                    <div className="w-full aspect-[4/5] bg-gradient-to-br from-black to-gray-700 flex items-center justify-center">
                      <Camera size={48} className="text-white opacity-30" />
                    </div>
                  )}
                  <div className="p-5">
                    <div className="text-xs font-mono uppercase opacity-60">{lb.season}</div>
                    <h3 className="font-black text-2xl uppercase mt-1">{lb.title}</h3>
                    <div className="mt-3 inline-flex items-center gap-2 text-sm font-black uppercase tracking-wider">
                      View <ChevronRight size={16} />
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {active && (
        <Lookbook
          lookbook={active}
          onClose={() => setActive(null)}
          onProductClick={(p) => {
            if (p?.slug && p?.category) window.location.href = `/${p.category}/${p.slug}`;
          }}
        />
      )}
    </div>
  );
};

export default LookbookPage;
